if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const targets = document.querySelectorAll('.about-reveal');

  if (targets.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('about-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    targets.forEach((target) => observer.observe(target));
  } else {
    targets.forEach((target) => target.classList.add('about-reveal--visible'));
  }
} else {
  document.querySelectorAll('.about-reveal').forEach((target) => target.classList.add('about-reveal--visible'));
}
